import React from "react";
import "./welcome-screen.css";
import emptyStateImage from "../../../images/new-images/popover-image.png";
import { Button } from "reactstrap";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";
import moment from "moment";

const Renderwelcomescreen = (props) => {
  return (
    <React.Fragment>
      <section className="dashboard-wrapper">
        <div className="content-center-align custom-padding">
          <div className="pad-around">
            <Container>
              <Row>
                <Col md="8">
                  <div className="col-content-wrapper">
                    <h1>
                      Welcome Aboard,
                      <span>{props.name}</span>
                    </h1>
                    <h2>{props.subtitle}</h2>
                    <div className="center-align">
                      <Row>
                        <Col md="3">
                          <img
                            src={
                              localStorage.getItem("baseLink") +
                              `/media/` +
                              props.InstrumentImage
                            }
                            alt="Loi Image"
                            style={{
                              width: "80%",
                              display: "block",
                              margin: "auto",
                            }}
                          />
                        </Col>
                        <Col md="9">
                          <div className="loi-content-wrapper">
                            <h1>{props.instrumentHeaderText}</h1>
                            {props.assessmentType == "assessment" ? (
                              <p>
                                {props.name}
                                's <span style={{marginLeft:'5px'}}>LOI</span>
                              </p>
                            ) : (
                              <p>
                                {props.inviteeName}
                                's <span style={{marginLeft:'5px'}}>LOI</span>
                              </p>
                            )}

                            <p
                              style={{
                                color: "rgba(51, 51, 51, 0.49)",
                                paddingTop: "15px",
                              }}
                            >
                              <span>
                                {props.expired ? "Expired" : "Expires"}
                              </span >
                              on
                              <span style={{ marginLeft:'5px'}}>
                                {moment(props.expiryDate).format("DD-MMM-YYYY")}
                              </span>
                            </p>
                            <Link
                              to={{
                                pathname: props.startLink,
                              }}
                              className="view-link"
                            >
                              <Button style={{ textTransform:'uppercase'}}>start</Button>
                            </Link>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </Col>
                <Col md="4">
                  <div className="col-img-wrapper">
                    <img src={emptyStateImage} alt="empty state image" />
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default Renderwelcomescreen;



// WEBPACK FOOTER //
// ./src/new/Components/Welcome/welcome-screen.jsx